import { type AcceptedLang } from '@lingoda/env';
import { getRoute } from './getRoute';

export const getRawPath = (name: Parameters<typeof getRoute>[0], locale: AcceptedLang): string =>
    getRoute(name, locale).path;
